import React from "react";
import "./TuPedido.css";
import banner from "../../media/tu_pedido_banner.png"
import tapas from "../../media/TapasTacones.png"

export default class TuPedido extends React.Component {
    render() {
        return (
            <div className="tu-pedido-container">
                <img className={"banner"} src={banner} alt=""/>
                <div className={"message"}>
                    Por favor, ingrese el código de seguimiento de su pedido. <br/>
                    Puede encontrarlo en su ticket de compra o en el mensaje que le enviamos por WhatsApp.
                </div>
                <div className="order-code">
                    <input type="text" placeholder={"Código de seguridad"}/>
                </div>
                <div className="progress-legend">
                    Progreso de tu pedido
                </div>
                <div className="squares-container">
                    <div className="square"></div>
                    <div className="square warning"></div>
                    <div className="square"></div>
                </div>
                <div className="order-status">
                    EN PROGRESO
                </div>
                <div className="order-subheader">
                    Trabajos
                </div>
                <div className="trabajos">
                    <div className="trabajo-item">
                        <div className="data"><img src={tapas} alt=""/><b>Trabajo 1</b></div>
                        <div className="status-data">
                            <div className="legend">Progreso</div>
                            <div className="squares-container">
                                <div className="square"></div>
                                <div className="square"></div>
                                <div className="square success"></div>
                            </div>
                        </div>
                    </div>
                    <div className="trabajo-item">
                        <div className="data"><img src={tapas} alt=""/><b>Trabajo 2</b></div>
                        <div className="status-data">
                            <div className="legend">Progreso</div>
                            <div className="squares-container">
                                <div className="square"></div>
                                <div className="square warning"></div>
                                <div className="square"></div>
                            </div>
                        </div>
                    </div>
                    <div className="trabajo-item">
                        <div className="data"><img src={tapas} alt=""/><b>Trabajo 3</b></div>
                        <div className="status-data">
                            <div className="legend">Progreso</div>
                            <div className="squares-container">
                                <div className="square danger"></div>
                                <div className="square"></div>
                                <div className="square"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}